<h2 matDialogTitle>Edit user rewards</h2>

<mat-dialog-content>

  <app-message-panel kind="ERROR" *ngIf="errors">{{errors}}</app-message-panel>

  <form [formGroup]="fg" novalidate>
    <mat-form-field appearance="fill">
      <mat-label>Points earned</mat-label>
      <input matInput formControlName="pointsEarned" />
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Points spent</mat-label>
      <input matInput formControlName="pointsSpent" />
    </mat-form-field>
  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [matDialogClose]="false">Cancel</button>
  <button mat-button (click)="onSave()">Save</button>
</mat-dialog-actions>
